//natives
import React from 'react';

export default (props) => {
    const classes = props.classes;
    const obj_user = props.obj_user;
    const nome_file = props.nome_file;
    const tempo = props.tempo;
    const dataAgenda = props.dataAgenda;
    const token = props.token;
    
    return (
        <>
            <div className={classes.container}>
                <div className={classes.fixed}>
                    <h3>Informações</h3>
                    <br/>
                    {obj_user}
                    <br/>
                    {"Data agendamento "+dataAgenda}
                    <br/>
                    {"Data impressão "+tempo}
                    <br/>
                    {"Token "+token}
                </div>
            </div>
            <br/>
            <h6>Comprovante do protocolo de pedido</h6>
        </>
    );
};